import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { ButtonComponent } from './button.component';

@Component({
  selector: 'rcp-link-button',
  template: `
    <a
      class="rcp-button"
      [class.primary]="color() === 'primary'"
      [class.positive]="color() === 'positive'"
      [class.negative]="color() === 'negative'"
      [class.disabled]="disabled()"
      [class.active]="active()"
      [class.rcp-button-small]="size() === 'small'"
      [class.rcp-button-full-width]="size() === 'full-width'"
      [title]="title()"
      [class.start]="textAlign() === 'start'"
      [href]="href()"
      [attr.target]="target() === 'external' ? '_blank' : null"
      [attr.rel]="target() === 'external' ? 'noopener noreferrer' : null"
    >
      @if (showIconAtStart()) {
        <span class="button-icon">
          <fa-icon [icon]="buttonIcon()" />
        </span>
      }
      <span class="button-label">
        <span class="button-label-content ellipsis">
          <ng-content></ng-content>
        </span>
      </span>
      @if (showIconAtEnd()) {
        <span class="button-icon">
          <fa-icon [icon]="buttonIcon()" />
        </span>
      }
    </a>
  `,
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FontAwesomeModule],
})
export class LinkButtonComponent extends ButtonComponent {
  // NOTE: ButtonComponent is extended by this component, so make sure to keep features in syncs
  readonly href = input.required<string>(); // make it required, so we don't use link buttons as normal buttons
  readonly target = input<'external' | 'internal'>('external');

  protected readonly showIconAtStart = computed(() => {
    const iconSlot = this.iconSlot();
    const target = this.target();
    const icon = this.icon();
    return (!!icon || target === 'external') && iconSlot === 'start';
  });
  protected readonly showIconAtEnd = computed(() => {
    const iconSlot = this.iconSlot();
    const target = this.target();
    const icon = this.icon();
    return (!!icon || target === 'external') && iconSlot === 'end';
  });
  protected readonly buttonIcon = computed(() => {
    const target = this.target();
    return target === 'external' ? faExternalLink : this.icon();
  });

  protected readonly faExternalLink = faExternalLink;
}
